var PROFILE_DOMAIN = process.env.REACT_APP_PROFILE_DOMAIN;
var S7_ID_URL = process.env.REACT_APP_S7_ID_URL;
/**
 * Формирует ссылку для перехода на сервис авторизации.
 *
 * @param redirectUrl - Ссылка для возврата после успешной авторизации на профиле (опциональный).
 * @param loggedIn - При значении `true` принудительно возвращает ссылку на приложение профиля.
 * */
export var getProfileLinkByAuthState = function (redirectUrl, loggedIn) {
    if (loggedIn === void 0) { loggedIn = false; }
    if (loggedIn) {
        return PROFILE_DOMAIN;
    }
    var params = new URLSearchParams({ origin: 'portal' });
    if (redirectUrl) {
        params.set('redirectUri', encodeURIComponent(redirectUrl));
        params.set('close', '0');
    }
    else {
        params.set('close', encodeURIComponent(window.location.href));
    }
    return "".concat(S7_ID_URL, "/?").concat(params);
};
